//
// Module for the Manual wizard's Initiate step
//
rs.module("participant/benefit/setup/manual/wizard/initiatestep",

    ["common/visibility", "common/select-helper"],

    function (visibility, selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, codeValues, backendUrls, flags, variables, basisPlans) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);

            var claimTypeHidden = stepContainer.js(jsSelectors.claimTypeHidden);

            var separationTypeSelect = stepContainer.js(jsSelectors.separationTypeSelect);
            var separationTypeSelectHelper = selectHelper.getHelper(separationTypeSelect);
            var separationSubTypeContainer = stepContainer.js(jsSelectors.separationSubTypeContainer, { required: false });
            var separationSubTypeSelect = separationSubTypeContainer.js(jsSelectors.separationSubTypeSelect, { required: false });
            var separationSubTypeSelectHelper = selectHelper.getHelper(separationSubTypeSelect);
            var basisPlanSelect = stepContainer.js(jsSelectors.basisPlanSelect, { required: false });
            var basisPlanSelectHelper = selectHelper.getHelper(basisPlanSelect);
            var splitPlanCheckbox = stepContainer.js(jsSelectors.splitPlanCheckbox);
            var benefitEffectiveDateInput = stepContainer.js(jsSelectors.benefitEffectiveDateInput, { required: false });
            var backDropMonthsSelect = stepContainer.js(jsSelectors.backDropMonthsSelect, { required: false });
            var backDropDateInput = stepContainer.js(jsSelectors.backDropDateInput, { required: false });
            var backDropDateHidden = stepContainer.js(jsSelectors.backDropDateHidden, { required: false });
            var dropBenefitEffectiveDate = stepContainer.js(jsSelectors.dropBenefitEffectiveDate, { required: false });
            var dropPlanSelect = stepContainer.js(jsSelectors.dropPlanSelect, { required: false });
            var dropPlanSelectHelper = selectHelper.getHelper(dropPlanSelect);
            var sourceBenefitSelect = stepContainer.js(jsSelectors.sourceBenefitSelect, { required: false });
            var sourceBenefitSelectHelper = selectHelper.getHelper(sourceBenefitSelect);
            var benefitTypeSelect = stepContainer.js(jsSelectors.benefitTypeSelect);
            var benefitTypeSelectHelper = selectHelper.getHelper(benefitTypeSelect);
            var separationDateInput = stepContainer.js(jsSelectors.separationDateInput, { required: false });
            var retirementBenefitTypeSelect = stepContainer.js(jsSelectors.retirementBenefitTypeSelect, { required: false });
            var retirementBenefitTypeSelectHelper = selectHelper.getHelper(retirementBenefitTypeSelect);
            var sourceBenefitContainer = stepContainer.js(jsSelectors.sourceBenefitContainer, { required: false });

            // Hookup separationTypeSelect change event
            separationTypeSelect.on("change", separationTypeChange);

            // On Sub Type change, update benefit types
            separationSubTypeSelect.on("change", updateBenefitTypeSelect);

            // Hookup basisPlanSelect change event
            basisPlanSelect.on("change", basisPlanChange);

            // Hookup separationDateInput change event
            separationDateInput.change(_.debounce(function () { separationDateChange(); }, 500));

            // Hookup benefitEffectiveDateInput change event
            benefitEffectiveDateInput.on("change", _.debounce(function () { benefitEffectiveDateChange(); }, 500));

            // Hookup backDropMonthsSelect change event
            backDropMonthsSelect.on("change", setBackDropDate);

            // Hookup dropBenefitEffectiveDate change event
            dropBenefitEffectiveDate.on("change", _.debounce(function () { dropBenefitEffectiveDateChange(); }, 500));

            // On DROP Plan change, update benefit types and retirement benefit types
            dropPlanSelect.on("change", updateRetirementBenefitTypeAndBenefitTypeSelect);

            // On Source Benefit change, 
            sourceBenefitSelect.on("change", sourceBenefitChange);

            // Separation Type change event
            function separationTypeChange() {

                // only alter visibility of Separation Sub Type if we're processing a retirement claim
                if (flags.isRetirementClaimType) {

                    // Get selected Separation Type
                    var selectedSeparationType = separationTypeSelect.val();

                    // Clear Separation Sub Type errors
                    separationSubTypeSelect.clearErrors();

                    // Reset Separation Sub Type selection
                    separationSubTypeSelectHelper.setValue("");

                    // Show/hide Separation Sub Type based on selected Separation Type
                    visibility.setVisible(separationSubTypeContainer, selectedSeparationType == codeValues.disabilityRetirement);
                }

                updateBenefitTypeSelect();
            }

            // Basis Plan change event
            function basisPlanChange() {
                var selectedPlanKey = parseInt(basisPlanSelect.val(), 10);
                var selectedPlan = basisPlans.find(p => p.planKey === selectedPlanKey);

                if (!selectedPlan) {
                    splitPlanCheckbox.setChecked(false);
                    splitPlanCheckbox.setDisabled(true);
                } else {
                    if (selectedPlan.splitPlanFlag) {
                        // Enable checkbox
                        splitPlanCheckbox.setDisabled(false);
                        splitPlanCheckbox.setChecked(true);
                    } else {
                        // Disable and uncheck checkbox
                        splitPlanCheckbox.setChecked(false);
                        splitPlanCheckbox.setDisabled(true);
                    }
                }

                if (flags.isDeathClaimType) {
                    updateBenefitTypeSelect();

                    $.get(backendUrls.updateBasisPlan, {
                        basisPlanKey: selectedPlanKey,
                        isBackDrop: flags.isBackDrop,
                        recalcFlag: flags.isRecalc
                    })
                        .done(function (response) {

                            // Update Separation Types
                            if (response.separationTypes?.length > 0) {
                                separationTypeSelectHelper.clearOptions();
                                separationTypeSelectHelper.replaceOptions(response.separationTypes, { withBlank: true });

                                if (response.separationType) {
                                    separationTypeSelectHelper.setValue(response.separationType);
                                }
                            } else {
                                separationTypeSelectHelper.clearOptions();
                            }
                            
                            // Update Separation Sub Types
                            if (response.separationSubTypes?.length > 0) {
                                separationSubTypeSelectHelper.clearOptions();
                                separationSubTypeSelectHelper.replaceOptions(response.separationSubTypes, { withBlank: true });

                                if (response.separationSubType) {
                                    separationSubTypeSelectHelper.setValue(response.separationSubType);
                                }
                            } else {
                                separationSubTypeSelectHelper.clearOptions();
                            }
                            
                            // Update Source Benefits
                            if (response.sourceBenefits?.length > 0) {
                                sourceBenefitContainer.show();
                                sourceBenefitSelectHelper.clearOptions();
                                sourceBenefitSelectHelper.replaceOptions(response.sourceBenefits, { withBlank: false });
                            } else {
                                sourceBenefitSelectHelper.clearOptions();
                                sourceBenefitContainer.hide();
                            }

                            // Update Available Benefits
                            if (response.availableBenefits?.length > 0) {
                                benefitTypeSelectHelper.clearOptions();
                                benefitTypeSelectHelper.replaceOptions(response.availableBenefits, { withBlank: true });
                            } else {
                                benefitTypeSelectHelper.clearOptions();
                            }
                        })
                        .fail(function () {});
                }
                if (flags.isRefundClaimType || flags.isRetirementClaimType) {
                    var isDvPlan = Array.isArray(variables.dvPlanKeys) && variables.dvPlanKeys.indexOf(selectedPlanKey) !== -1;
                    var hasDvDate = !!variables.dvPlanSeparationDate;
                    var hasDefaultDate = !!variables.defaultSeparationDate;

                    if (isDvPlan && hasDvDate) {
                        // Default from DV
                        separationDateInput.val(variables.dvPlanSeparationDate).clearErrors();
                    } else if (hasDefaultDate) {
                        separationDateInput.val(variables.defaultSeparationDate).clearErrors();
                    }
                    else {
                        separationDateInput.val("");
                    }
                }
            }

            // Benefit Effective Date change event
            function benefitEffectiveDateChange() {
                setBackDropDate();

                updateBenefitTypeSelect();
            }

            // DROP Entry Date change event
            function dropBenefitEffectiveDateChange() {

                if (dropBenefitEffectiveDate.val() && dropBenefitEffectiveDate.valid()) {

                    // reload DROP plans
                    dropPlanSelectHelper.loadOptionsFrom(
                        backendUrls.getDropPlans,
                        {
                            dropEntryDate: dropBenefitEffectiveDate.val(),
                            selectedDropPlanKey: dropPlanSelect.val()
                        },
                        {
                            withBlank: true
                        },
                        function () {
                            // if plans exist, update Benefit Types
                            if (this.getOptions().length > 0) {
                                updateBenefitTypeSelect();
                            }
                        });
                }
            }

            // Separation Date change event
            function separationDateChange() {

                separationDateInput.clearErrors();

                if (separationDateInput.val() && separationDateInput.valid()) {

                    // Get entered Separation Date
                    var separationDate = separationDateInput.val();

                    var hasDefaultDate = !!variables.defaultSeparationDate;

                    // If the Separation Date was not system defaulted, populate Effective Date
                    if (flags.isRecalc || !hasDefaultDate) {
                        var effectiveDate = new Date(separationDate);
                        var newEffectiveDate = new Date(
                            Date.UTC(
                                effectiveDate.getUTCFullYear(),
                                effectiveDate.getUTCMonth() + 1,
                                1,
                                effectiveDate.getUTCHours(),
                                effectiveDate.getUTCMinutes()
                            )
                        );
                        benefitEffectiveDateInput.val(new Date(newEffectiveDate).toISODateString()).clearErrors();
                    }

                    // Trigger benefit effective date change
                    benefitEffectiveDateChange();
                }
            }

            // Update the options presented for both retirement benefit type and benefit type
            function updateRetirementBenefitTypeAndBenefitTypeSelect() {
                updateBenefitTypeSelect();
                updateRetirementBenefitType();
            }

            // Update the options presented for benefit type
            function updateBenefitTypeSelect() {

                benefitTypeSelect.clearErrors();

                var basisPlan = basisPlanSelect.val();
                var separationType = separationTypeSelect.val();
                var separationSubType = separationSubTypeSelect.val();
                var benefitEffectiveDate = benefitEffectiveDateInput.val() && benefitEffectiveDateInput.valid() ? benefitEffectiveDateInput.val() : dropBenefitEffectiveDate.val();

                if (basisPlan &&
                    separationType &&
                    (separationSubTypeContainer.length === 0 || separationSubType || !separationSubTypeContainer.is(':visible')) &&
                    benefitEffectiveDate) {

                    benefitTypeSelectHelper.loadOptionsFrom(
                        backendUrls.getBenefitTypes,
                        {
                            claimType: claimTypeHidden.val(),
                            benefitEffectiveDate: benefitEffectiveDate,
                            basisPlanKey: basisPlan,
                            separationType: separationType,
                            separationSubType: separationSubType,
                            dropPlanKey: dropPlanSelect.val()
                        },
                        {
                            withBlank: true,
                            maintainSelection: true
                        },
                        function () {
                            //if there is only one option (and blank), select the option by default
                            if (this.getOptions().length == 2) {
                                this.selectIndex(1);
                            }
                        });
                } else {
                    benefitTypeSelectHelper.clearOptions();
                }
            }

            // Update the options presented for retirement benefit types
            function updateRetirementBenefitType() {
                retirementBenefitTypeSelect.clearErrors();

                retirementBenefitTypeSelectHelper.loadOptionsFrom(
                    backendUrls.getRetirementBenefitTypes,
                    {
                        dropPlanKey: dropPlanSelect.val(),
                        effectiveAsOfDate: dropBenefitEffectiveDate.val()
                    },
                    {
                        withBlank: true,
                        maintainSelection: true
                    },
                    function () {
                        //if there is only one option (and blank), select the option by default
                        if (this.getOptions().length == 2) {
                            this.selectIndex(1);
                        }
                    }
                );

            }

            // Set Back Drop Date
            function setBackDropDate() {
                if (benefitEffectiveDateInput.val() && benefitEffectiveDateInput.valid() && backDropMonthsSelect.val()) {
                    $.ajax({
                        url: backendUrls.getBackDropDate,
                        data: {
                            benefitEffectiveDate: benefitEffectiveDateInput.val(),
                            backDropMonths: backDropMonthsSelect.val()
                        },
                        success: function (data) {
                            backDropDateInput.val(data.backDropDate);
                            backDropDateHidden.val(data.backDropDate);
                        }
                    });
                }
                else {
                    backDropDateInput.val("");
                    backDropDateHidden.val("");
                }
            }

            // Update Basis Type select, Benefit Type select, and Split Plan checkbox
            function sourceBenefitChange() {

                if (!flags.isDeathClaimType) {
                    basisPlanSelect.clearErrors();
                    benefitTypeSelect.clearErrors();

                    var sourceBenefit = sourceBenefitSelect.val();
                    var separationType = separationTypeSelect.val();
                    var separationSubType = separationSubTypeSelect.val();

                    if (sourceBenefit && separationType && separationSubType) {

                        $.get(
                            backendUrls.getBasisPlans,
                            {
                                claimType: claimTypeHidden.val(),
                                claimPaymentSourceKey: sourceBenefit,
                                separationType: separationType,
                                separationSubType: separationSubType
                            },
                            function (data) {
                                // suppressChange: true to prevent firing of basisPlanChange
                                basisPlanSelectHelper.replaceOptions(data.basisPlans, { suppressChange: true });
                                benefitTypeSelectHelper.replaceOptions(data.benefitTypes, { withBlank: true });

                                splitPlanCheckbox.prop('disabled', data.basisPlans.length <= 1);
                            }
                        );

                    } else {
                        basisPlanSelectHelper.clearOptions();
                        benefitTypeSelect.clearOptions();

                        splitPlanCheckbox.prop('disabled', true);
                    }
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);